var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scroll-div scroll-div-device status_page" },
    [
      _vm.statusApiCallDone
        ? _c("div", { staticClass: "col-md-12 chart-title" }, [
            _c("span", [_vm._v("Number of registrations by status")]),
          ])
        : _vm._e(),
      _vm.statusApiCallDone
        ? _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 horizontal_legend",
              attrs: { id: "legend2" },
            },
            [
              _c("span", { staticClass: "key_dot legend_active" }),
              _c("span", { staticClass: "legend_name" }, [_vm._v("Active")]),
              _c("span", { staticClass: "key_dot legend_pending" }),
              _c("span", { staticClass: "legend_name" }, [_vm._v("Pending")]),
              _c("span", { staticClass: "key_dot legend_expsoon" }),
              _c("span", { staticClass: "legend_name" }, [
                _vm._v("Expiring soon"),
              ]),
              _c("span", { staticClass: "key_dot legend_expired" }),
              _c("span", { staticClass: "legend_name" }, [_vm._v("Expired")]),
            ]
          )
        : _vm._e(),
      _c("div", {
        staticClass: "col-md-12 pie-chart",
        attrs: { id: "pieDiv" },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }